import React, { Fragment, useMemo, useState } from 'react';
import AppTable from '../../../../constants/AppTable';
import { SaleResult, TransactionPurchase } from '../../../../helpers/models/Models';
import { LoadingSpinner } from '../../../../constants/AppLoading';
import { formatMoney } from '../../../../helpers/DateFormat';


interface ProductListViewProps {
    data: {
        results: SaleResult[];
        previous: string | null;
        next: string | null;
    } | null;
    loading: boolean;
    error: string | null;
    setOnURL: React.Dispatch<React.SetStateAction<string>>;
    handleFormSuccess: () => void;
}
const SalesReportListView: React.FC<ProductListViewProps> = ({ data, loading, error, handleFormSuccess, setOnURL }) => {
    const columns = [
        { header: 'Product Name', accessor: 'product_name', sortable: true },
        { header: 'Member Name', accessor: 'mem_name', sortable: false },
        { header: 'Member Phone No.', accessor: 'mem_phone_no', sortable: false },
        { header: 'Marga/Tole', accessor: 'marga_tole_name', sortable: false },
        { header: 'TSN', accessor: 'tsn', sortable: false },
        { header: 'Sales QTY', accessor: 'sales_qty', sortable: false },
        { header: 'Sales Rate', accessor: 'purchase_rate', sortable: false },
        { header: 'Sales Total Amt', accessor: 'sales_tot_amt', sortable: false },
        { header: 'Store Name', accessor: 'store_name', sortable: false },
        { header: 'Store Phone No.', accessor: 'phone_no', sortable: false },
        { header: 'Sales Date', accessor: 'pur_sale_date', sortable: false },
        { header: 'Discount Amt', accessor: 'dis_amt', sortable: false },
        { header: 'Discount Percentage', accessor: 'dis_per', sortable: false },
        { header: 'With VAT', accessor: 'vat_amt', sortable: false },
    ];

    const modifiedData = useMemo(() => {
        if (!data) return [];
        return data.results.map((item: SaleResult) => ({
            sn: item.sn,
            tsn: item.tsn,
            mem_name: item.mem_name,
            mem_phone_no: item.mem_phone_no,
            sale_issue: item.sale_issue,
            sales_qty: `${item.sales_qty} ${item.sales_unit_name}`,
            sales_tot_amt: formatMoney(item.sales_tot_amt??0),
            dis_amt: item.dis_amt,
            dis_per: item.dis_per,
            vat_amt: item.vat_amt,
            purchase_rate:  formatMoney(item.sales_rate??0),
            pur_sale_date: item.pur_sale_date,
            purchase_unit_name: item.sales_unit_name,
            store_name: item.store_name,
            phone_no: item.phone_no,
            product_name: item.product_name,
            remarks: item.remarks,
            marga_tole_name: item.marga_tole_name,
        }));
    }, [data]);


   
    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingSpinner />
            </div>
        );
    }

    if (error) {
        return <p>Error loading data: {error}</p>;
    }

    return (
        <Fragment>
            <AppTable
                columns={columns}
                data={modifiedData}
                onNext={() => data?.next && setOnURL(data.next)}
                onPrev={() => data?.previous && setOnURL(data.previous)}
            />
          
        </Fragment>
    )
}

export default SalesReportListView